import React from "react";
import { Field, ErrorMessage } from "formik";

// Reusable Country Code Select Component
const CountryCodeSelect = ({ name, countries }) => (
  <Field
    as="select"
    name={name}
    className="form-select"
    style={{ maxWidth: "150px" }}
  >
    <option value="">Country Code</option>
    {countries.map((country) => (
      <option key={country.id} value={country.countryCode}>
        {country.countryCode} ({country.name})
      </option>
    ))}
  </Field>
);

// Reusable Phone Number Field Component
const PhoneNumberFieldComponent = ({
  label,
  countryCodeName,
  numberName,
  placeholder,
  required = false,
  countries,
}) => (
  <div className="col-12 mb-3">
    <label className="form-label">
      {label}
      {required && <span className="text-danger">*</span>}
    </label>
    <div className="input-group">
      <CountryCodeSelect name={countryCodeName} countries={countries} />
      <Field
        type="text"
        name={numberName}
        className="form-control"
        placeholder={placeholder}
      />
    </div>
    {required && (
      <ErrorMessage name={numberName} component="div" className="text-danger" />
    )}
  </div>
);

export default PhoneNumberFieldComponent;
